import { Skeleton } from '@mui/material';
import { useNewCustomTranslations } from 'hooks';
import i18next from 'i18next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useGetUserProfileQuery } from '@fiji/common/src/features/profile/profileApi';
import { ApiEndpointType, ApiResponseType } from '@fiji/common/src/features/common/commonTypes';
import { Profile } from '@fiji/common/src/types';
import { DEFAULT_LANGUAGE } from '@fiji/common/src/constants/cacheTimeout';

const resolveLanguage = (locale: any, userProfileData: any, globalLocale: string | null): string =>
    locale ?? userProfileData?.data?.language ?? globalLocale ?? DEFAULT_LANGUAGE;

export const CustomTransComponent = ({
    translationKey,
    size,
    replace,
    components,
    skip,
    customT,
    locale,
    defaultValue,
}: {
    translationKey: any;
    size?: any;
    replace?: any;
    components?: any;
    skip?: boolean;
    customT?: any;
    locale?: any;
    defaultValue?: string;
}): any => {
    const { t } = useTranslation();
    const { data: userProfileData } = useGetUserProfileQuery({}, { skip }) as ApiEndpointType<ApiResponseType<Profile>>;
    const globalLocale = window.localStorage.getItem('globalLocale');
    const language = resolveLanguage(locale, userProfileData, globalLocale);
    const namespace = typeof translationKey === 'string' ? translationKey.split(':')[0] : '';
    const { width = 200, height = 15 } = size ?? {};
    useNewCustomTranslations(namespace, skip);

    const getCustomTransComponent = (): any => {
        if (!i18next.hasResourceBundle(language, namespace)) {
            return (
                <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={width}
                    height={height}
                    sx={{ marginBottom: '10px', marginTop: '10px' }}
                />
            );
        } else if (customT) {
            return t(translationKey, { defaultValue });
        }
        return <Trans i18nKey={translationKey} defaults={defaultValue} values={replace} components={components} />;
    };

    return <>{getCustomTransComponent()}</>;
};
